var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.items)?_c('ShowAnn',{attrs:{"items":_vm.items,"menu":_vm.role === 0,"updateInfo":""},on:{"delete":_vm.deleteAnn}}):_c('Spinner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }